<template>
  <div class="col s12 no-padding full-height-percent">
    <div class="row application-forgotPassword app-body-height">
      <div class="col left-align">
        <div>
          <h5 class="blue-color">{{ $t('views.login.forgotpasswordheader') }}</h5>
          <p> {{ $t('views.login.forgotpassworddescription') }} </p>
        </div>

        <form>
          <div class="row">
            <div class="input-field col s12 no-margin-bottom">
              <input
                id="email"
                type="email"
                class="validate"
                v-model="username">
              <label for="email">{{ $t('views.login.email') }}</label>
              <span
                class="helper-text"
                data-error="Email address format is incorrect"
              />
            </div>
            <div
              v-if="error"
              class="col s12 forgotPassword-error">
              <div>{{ $t(error) }}</div>&nbsp;&nbsp;&nbsp;
              <i class="material-icons">warning</i>
            </div>
          </div>
        </form>

        <div class="col s12 valign-wrapper no-padding">
          <a
            @click="sendPassword()"
            class="waves-effect waves-light btn signin-button">{{ $t('views.login.send') }}</a>
        </div>

      </div>
    </div>
    <div class="row app-footer-height app-footer-margins">
      <div class="col s6 left-align no-padding">
        <a
          class="blue-color"
          @click="$router.go(-1)">
        <p class="no-margin cursor-hand"><b>{{ $t('views.login.back') }}</b></p></a>
      </div>
      <div class="col s6 right-align no-padding">
        <p class="no-margin grey-color">{{ this.$parent.versionNumber }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      username: undefined,
      error: undefined
    }
  },
  methods: {
    sendPassword () {
      this.error = 'notimplemented'
    }
  }
}
</script>

<style scoped>
  .application-forgotPassword {
    padding-top: 144px;
    padding-left: 53px;
    padding-right: 49px;
  }

    .forgotPassword-error {
    font-size: 12px;
    color:red;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>



// WEBPACK FOOTER //
// src/pages/login/_ForgotPassword.vue